export const LOADING_EXPERIENCE = "LOADING_EXPERIENCE";
export const SAVE_LOADING_EXPERIENCE = "SAVE_LOADING_EXPERIENCE";
export const GET_EXPERIENCE = "GET_EXPERIENCE";
export const FORM_FAIL_EXPERIENCE = "FORM_FAIL_EXPERIENCE";
export const EXPERIENCE_FAIL = "EXPERIENCE_FAIL";
export const LOADING_EXPERIENCE_BY_ID = "LOADING_EXPERIENCE_BY_ID";
export const GET_EXPERIENCE_BY_ID = "GET_EXPERIENCE_BY_ID";
export const SAVE_LOADING_EXPERIENCE_BY_ID = "SAVE_LOADING_EXPERIENCE_BY_ID";
